export const expenseReceiptAccept = "application/pdf,image/png,image/jpeg";

export function expenseReceiptError(file) {
  if (!file) return "Choose a receipt to upload.";
  if (!file.size) return "Receipt file is empty. Choose another file.";
  if (file.size > 10 * 1024 * 1024) return "Receipt must be 10 MB or smaller";
  if (!/\.(pdf|png|jpe?g)$/i.test(file.name) ||
      (file.type && !expenseReceiptAccept.split(",").includes(file.type))) {
    return "Choose a PDF, PNG or JPG receipt.";
  }
  return "";
}
